// extracted by mini-css-extract-plugin
export var button = "_1d-0";
export var buttonContent = "_1d-e";
export var buttonGroup = "_1d-c";
export var dontRestrainIconWidth = "_1d-a";
export var dropdownButton = "_1d-b";
export var iconContainer = "_1d-9";
export var lg = "_1d-4";
export var md = "_1d-3";
export var pending = "_1d-f";
export var sm = "_1d-2";
export var spinner = "_1d-d";
export var squared = "_1d-8";
export var wrapText = "_1d-g";
export var xl = "_1d-5";
export var xs = "_1d-1";
export var xxl = "_1d-6";
export var xxxl = "_1d-7";